import { addBill, uplaodBillMedia } from 'app/api/bill';
import { getMallList } from 'app/api/mall';
import { getStoreListOnMallID } from 'app/api/store';
import { LocalSessionKey } from 'app/constants/app-constants';
import {
  billValidationRules,
  validate,
} from 'app/constants/validation-constants';
import Message from 'app/utils/Message';
import { dataformatChangesYearToDate } from 'app/utils/Parsers';
import Toast from 'app/utils/Toast';
import { LocalStorage } from 'app/utils/storage';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';

const useCreateBill = () => {
  const user = JSON.parse(LocalStorage.get(LocalSessionKey.USER_INFO));

  const navigate = useNavigate();
  const location = useLocation();
  const [mallList, setMallList] = useState([]);
  const [storeList, setStoreList] = useState([]);
  const [pageLoading, setPageLoading] = useState(false);
  const [error, setErrors] = useState({});

  const [values, setValues] = useState({
    phone_number: '',
    mallId: null,
    storeId: null,
    categoryId: null,
    // coverImage stores the S3/CloudFront URL returned by /file/upload-bill —
    // used both as the <img src> preview and as the value persisted to
    // bill_documents.bill_url via the addBill call.
    coverImage: null,
    invoice_date: null,
    bills: [],
    shopping_amount: null,
    invoice_number: '',
    approvedBy: user.id,
  });

  const eventId = location?.state?.id ? location?.state?.id : '';

  useEffect(() => {
    getMallListforDropdown();
  }, []);

  async function getMallListforDropdown() {
    setPageLoading(true);
    let response = await getMallList(1);
    setPageLoading(false);
    if (response && response?.responseCode === 200) {
      let temp = await response?.data?.malls?.map((item, index) => {
        return {
          ...item,
          value: item.id,
          label: item.name,
        };
      });
      setMallList(temp);
    } else {
      Toast.error(
        response?.data ? response?.data : Message?.Error?.COMMON_MESSAGE
      );
    }
  }
  async function getStoreListDropdown(value) {
    setPageLoading(true);
    let response = await getStoreListOnMallID(value);
    setPageLoading(false);
    if (response && response?.responseCode === 200) {
      let temp = await response?.data?.map((item, index) => {
        return {
          ...item,
          value: item.id,
          label: item.storeName,
        };
      });
      setStoreList(temp);
    } else {
      Toast.error(
        response?.data ? response?.data : Message?.Error?.COMMON_MESSAGE
      );
    }
  }

  const callAddOrUpdateAPI = async () => {
    setPageLoading(true);
    let response = {};
    let temp = dataformatChangesYearToDate(values.invoice_date);
    let senddata = {
      ...values,
      invoice_date: temp,
      // values.coverImage is the S3/CloudFront URL — persisted as-is to
      // bill_documents.bill_url and rendered directly on read.
      bills: [values.coverImage],
    };
    senddata.shopping_amount = parseFloat(values.shopping_amount);
    delete senddata.coverImage;
    response = await addBill({ ...senddata });
    setPageLoading(false);
    if (response?.responseCode === 200) {
      Toast.success('Bill Added Successfully');
      navigate(-1);
    } else {
      Toast.error(
        response?.response?.message
          ? response?.response?.message
          : Message.Error.COMMON_MESSAGE
      );
    }
  };

  const handleCreateBill = (e) => {
    e.preventDefault();
    const validationErrors = validate(values, billValidationRules);
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length === 0) {
      callAddOrUpdateAPI();
    }
  };

  const handleChange = (e) => {
    if (e && e.target) {
      const { name, value } = e.target;
      setValues((prevValues) => ({
        ...prevValues,
        [name]: name === 'phone' ? parseInt(value) : value,
      }));

      if (error[name]) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: '',
        }));
      }
    }
  };
  function handleMallChange(e) {
    if (e && e.target) {
      const { name, value } = e.target;
      setStoreList([]);

      getStoreListDropdown(value);

      setValues({
        ...values,
        [name]: value,
        storeId: '',
        categoryId: '',
      });

      if (error[name]) {
        setErrors({
          ...error,
          [name]: '',
          storeId: '',
        });
      }
    }
  }
  function handleChangeStore(e) {
    if (e && e.target) {
      const { name, value } = e.target;

      const matchingStore = storeList.find((store) => store.id === value);
      setValues({
        ...values,
        [name]: value, // Update the value of the selected storeId
        categoryId: matchingStore ? matchingStore.categoryId : '', // Update the categoryId if a match is found
      });

      if (error[name]) {
        setErrors({
          ...error,
          storeId: '',
        });
      }
    }
  }

  const setChange = (name, val) => {
    setValues((prevState) => ({
      ...prevState,
      [name]: val,
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: '',
    }));
  };

  const uploadMediaHandler = async (file, name) => {
    if (!file) {
      setChange(name, null);
      return;
    }

    const response = await uplaodBillMedia(file);
    if (response.responseCode === 200) {
      Toast.success('Image upload Successful');
      // Backend returns { url } — a direct S3/CloudFront URL. Used both
      // for the in-form preview and persisted to bill_documents.bill_url.
      setChange(name, response?.data?.url ?? null);
    } else {
      Toast.error('Image upload failed');
    }
  };

  return {
    mallList,
    storeList,
    handleMallChange,
    handleChangeStore,
    handleChange,
    values,
    error,
    setValues,
    handleCreateBill,
    pageLoading,
    eventId,
    uploadMediaHandler,
    navigate,
    setChange,
  };
};

export default useCreateBill;
